import TabItem from '@components/tab/TabItem';
import TabList from '@components/tab/TabList';
import { useStepFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

interface Props {
    type: 'READ' | 'WRITE';
}

function InquiryTabHeader({ type }:Props) {
    const { t } = useTranslation('inquiry');
    const { replaceStep } = useStepFlow('InquiryActivity');
    return (
        <TabList variant='solid'>
            <TabItem selected={type === 'WRITE'}
                onClick={() => replaceStep({ type: 'WRITE' })}>
                {t('tab.write')}
            </TabItem>
            <TabItem selected={type === 'READ'}
                onClick={() => replaceStep({ type: 'READ' })} >
                {t('tab.read')}
            </TabItem>
        </TabList>
    );
}

export default InquiryTabHeader;
